export { Icon3d } from './Icon3d'
export { IconActiveFolder } from './IconActiveFolder'
export { IconAddTab } from './IconAddTab'
export { IconDocBlank } from './IconDocBlank'
export { IconDomainTWT } from './IconDomainTWT'
export { IconDomainZ } from './IconDomainZ'
export { IconDots } from './IconDots'
export { IconFolderWell } from './IconFolderWell'
export { IconGeoBD } from './IconGeoBD'
export { IconGeoDomain } from './IconGeoDomain'
export { IconGeoInterpretation } from './IconGeoInterpretation'
export { IconGeoLayer } from './IconGeoLayer'
export { IconGeoMap } from './IconGeoMap'
export { IconGeoML2 } from './IconGeoML2'
export { IconGeoObjAmpl } from './IconGeoObjAmpl'
export { IconGeoObjChs } from './IconGeoObjChs'
export { IconGeoObjCrossline } from './IconGeoObjCrossline'
export { IconGeoObjCrosslineL } from './IconGeoObjCrosslineL'
export { IconGeoObjCrosslineProfile } from './IconGeoObjCrosslineProfile'
export { IconGeoObjCrosslineZ } from './IconGeoObjCrosslineZ'
export { IconGeoObjectGisChild } from './IconGeoObjectGisChild'
export { IconGeoObjectGisMain } from './IconGeoObjectGisMain'
export { IconGeoObjectInc } from './IconGeoObjectInc'
export { IconGeoObjectLithology } from './IconGeoObjectLithology'
export { IconGeoObjectMarker } from './IconGeoObjectMarker'
export { IconGeoObjectMarkers } from './IconGeoObjectMarkers'
export { IconGeoObjectRigis } from './IconGeoObjectRigis'
export { IconGeoObjectSaturation } from './IconGeoObjectSaturation'
export { IconGeoObjectTrajectory } from './IconGeoObjectTrajectory'
export { IconGeoObjectWell } from './IconGeoObjectWell'
export { IconGeoObjectWellBore } from './IconGeoObjectWellBore'
export { IconGeoObjectWells } from './IconGeoObjectWells'
export { IconGeoObjFault } from './IconGeoObjFault'
export { IconGeoObjFaults } from './IconGeoObjFaults'
export { IconGeoObjHorizon } from './IconGeoObjHorizon'
export { IconGeoObjHorizon2D } from './IconGeoObjHorizon2D'
export { IconGeoObjHorizon3D } from './IconGeoObjHorizon3D'
export { IconGeoObjHorizons } from './IconGeoObjHorizons'
export { IconGeoObjInterpretations } from './IconGeoObjInterpretations'
export { IconGeoObjSeismdataVert } from './IconGeoObjSeismdataVert'
export { IconGeoObjSeismdataVerts } from './IconGeoObjSeismdataVerts'
export { IconGeoObjSeismic } from './IconGeoObjSeismic'
export { IconGeoObjSeismic2D } from './IconGeoObjSeismic2D'
export { IconGeoObjSeismic3D } from './IconGeoObjSeismic3D'
export { IconGeoObjShot } from './IconGeoObjShot'
export { IconGeoObjStratigraphy } from './IconGeoObjStratigraphy'
export { IconGeoObjZone } from './IconGeoObjZone'
export { IconGeoSpeed } from './IconGeoSpeed'
export { IconGeoVelocity } from './IconGeoVelocity'
export { IconGeoVelocityFolder } from './IconGeoVelocityFolder'
export { IconGeoWindowB } from './IconGeoWindowB'
export { IconInterpretations } from './IconInterpretations'
export { IconIntersectionPoints } from './IconIntersectionPoints'
export { IconIronMap } from './IconIronMap'
export { IconMapFetching } from './IconMapFetching'
export { IconMaps } from './IconMaps'
export { IconObjectTree } from './IconObjectTree'
export { IconPanelAdd } from './IconPanelAdd'
export { IconPolygon } from './IconPolygon'
export { IconPolygonMultiple } from './IconPolygonMultiple'

import {
  IconDomainTWT,
  IconDomainZ,
  IconDots,
  IconFolderWell,
  IconGeoInterpretation,
  IconGeoLayer,
  IconGeoMap,
  IconGeoObjAmpl,
  IconGeoObjChs,
  IconGeoObjCrossline,
  IconGeoObjCrosslineL,
  IconGeoObjCrosslineProfile,
  IconGeoObjCrosslineZ,
  IconGeoObjectGisChild,
  IconGeoObjectGisMain,
  IconGeoObjectInc,
  IconGeoObjectLithology,
  IconGeoObjectMarker,
  IconGeoObjectMarkers,
  IconGeoObjectRigis,
  IconGeoObjectSaturation,
  IconGeoObjectTrajectory,
  IconGeoObjectWell,
  IconGeoObjectWellBore,
  IconGeoObjectWells,
  IconGeoObjFault,
  IconGeoObjFaults,
  IconGeoObjHorizon,
  IconGeoObjHorizon2D,
  IconGeoObjHorizon3D,
  IconGeoObjHorizons,
  IconGeoObjInterpretations,
  IconGeoObjSeismdataVert,
  IconGeoObjSeismdataVerts,
  IconGeoObjSeismic,
  IconGeoObjSeismic2D,
  IconGeoObjSeismic3D,
  IconGeoObjShot,
  IconGeoObjStratigraphy,
  IconGeoObjZone,
  IconGeoSpeed,
  IconGeoVelocity,
  IconGeoVelocityFolder,
  IconInterpretations,
  IconIntersectionPoints,
  IconIronMap,
  IconMaps,
  IconPolygon,
  IconPolygonMultiple,
} from '../icons'

// TODO: возможно стоит добавить вынести это в какие-нибудь конверторы
/// Этот объект - одновременно и конвертер для названий иконок приходящих с бэка. Перед его изменением стоит подумать
export const AllTreeIcons = {
  IconFolderWell,
  IconGeoInterpretation,
  IconGeoLayer,
  IconGeoMap,
  IconGeoObjAmpl,
  IconGeoObjChs,
  IconGeoObjCrossline,
  IconGeoObjectGisChild,
  IconGeoObjectGisMain,
  IconGeoObjectInc,
  IconGeoObjectMarkers,
  IconGeoObjectWell,
  IconGeoSpeed,
  IconGeoObjectWells,
  IconGeoObjHorizon,
  IconGeoObjHorizon2D,
  IconGeoObjHorizon3D,
  IconGeoObjHorizons,
  IconGeoObjInterpretations,
  IconGeoObjFault,
  IconGeoObjFaults,
  IconGeoObjSeismic,
  IconGeoObjectSaturation,
  IconGeoObjectLithology,
  IconGeoObjSeismic2D,
  IconGeoObjSeismic3D,
  IconGeoObjShot,
  IconGeoObjZ: IconDomainZ,
  IconGeoObjTWT: IconDomainTWT,
  IconIronMap,
  IconMaps,
  IconGeoObjCrosslineL,
  IconGeoObjectMarker,
  IconGeoVelocity,
  IconGeoVelocityFolder,
  IconInterpretations,
  IconGeoObjSeismdataVerts,
  IconIntersectionPoints,
  IconGeoObjCrosslineZ,
  IconGeoObjStratigraphy,
  IconGeoObjectRigis,
  IconPolygonMultiple,
  IconPolygon,
  IconGeoObjectTrajectory,
  IconGeoObjCrosslineProfile,
  IconGeoObjZone,
  IconDots,
  IconGeoObjSeismdataVert,
  IconGeoObjectWellBore,
} as const
